import { http, camelify } from '../rest';

export function fetchSalesforceData(http, camelify, demo) {
  return {
    async execute() {
      let data;
      if (demo) {
        const file = await import('./fetchSalesforceData.data');
        data = file.default;
      } else {
        const response = await http.get('/salesforce/user_data');
        data = response.data;
      }
      return camelify(data);
    },
  };
}

export default fetchSalesforceData(http, camelify, process.env.DEMO);
